export default "__VITE_ASSET__Bdu7icb6__"